import { APP } from 'appenv';

// eslint-disable-next-line import/prefer-default-export
export function envSwitch<T>(providersMap: [string[] | string, T][] = [], defaultValueProvider: T): T {
  return (providersMap.find(([apps]) => (apps instanceof Array ? apps.indexOf(APP) !== -1 : apps === APP)) ?? [null, defaultValueProvider])[1];
}
